import React, { useEffect, useState } from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQuery } from "@tanstack/react-query";
import { getScheduleByNoc } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import NocScheduleTable from "components/common/schedule/NocScheduleTable";
import { ALL_URL, dateFormat, getDateTimeFormat, groupByDate, SELECTOR_DISPLAY_TYPE } from "helpers/utils";
import { Accordion, Stack } from "react-bootstrap";
import SelectorDay from "components/common/selector-day/SelectorDay";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import SelectorEvent from "components/common/selectors/SelectorEvent";
import DayList from 'components/common/selector-day/Day';
import useViewport from "components/general/useViewPort";
import { getGlobalProps } from "state-management/selectors";
import SelectorNoc from "components/common/selectors/selector-noc";
import DateTime from "components/presentation/DateTime";
import SelectorTimeZone from "components/common/selectors/selector-timezone";


const ScheduleByNoc = () => {
    const { mirs_competition, mirs_language, mirs_noc, mirs_discipline, mirs_event, mirs_date } = useUrlFriendlyToParameters();
    const [events, setEvents] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [datesArray, setDatesArray] = useState({ competition_schedule: [] });
    const [datesScheduleMap, setDatesScheduleMap] = useState(new Map());
    const { breakPoint } = useViewport();

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['scheduleDataByNOC', mirs_competition, mirs_language, mirs_noc],
            queryFn: getScheduleByNoc,
            refetchInterval: 30000,
        });

    useEffect(() => {

        const tempEvents = new Set();
        const tempDates = new Set();
        const tempDisciplines = new Set();
        const filteredScheduleArray = [];
        // use one iteration instead of mutiple filter method
        data?.schedulesByNoc?.forEach(scheduleItem => {
            // filter by phase type
            if (scheduleItem?.eventUnit.phase.type.match('[13]')) {
                let tempScheduleItem = scheduleItem;
                // handle smart filter
                const formattedStartDate = dateFormat(scheduleItem?.startDate, getGlobalProps.timezone, 'YYYY-MM-DD');

                let tempDiscipline = scheduleItem?.discipline?.code;
                let tempEvent = scheduleItem?.eventUnit?.phase?.event.code;
                let tempDate = formattedStartDate;
                // filter by phase type
                if (mirs_date && mirs_date !== ALL_URL.ALL_DAYS && new Date(mirs_date).toISOString() !== new Date(formattedStartDate).toISOString()) {

                    tempDiscipline = '';
                    tempEvent = '';
                    tempScheduleItem = '';
                };

                if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC && mirs_discipline !== scheduleItem?.discipline?.code) {
                    tempDate = '';
                    tempEvent = '';
                    tempScheduleItem = '';
                };
                if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT && mirs_event !== scheduleItem?.eventUnit?.phase?.event?.code) {
                    tempDate = '';
                    tempScheduleItem = '';
                };

                if (!mirs_discipline || mirs_discipline === ALL_URL.ALL_DISC) {
                    tempEvent = '';
                };

                if (tempDate) {
                    tempDates.add(tempDate);
                };

                if (tempDiscipline) {
                    tempDisciplines.add(tempDiscipline);
                };

                if (tempEvent) {
                    tempEvents.add(tempEvent);
                };

                if (tempScheduleItem) {
                    filteredScheduleArray.push(tempScheduleItem);
                };

            };
        });

        const sortedTempDates = Array.from(tempDates).sort((a, b) => new Date(a) - new Date(b));
        let itemsDates = { competition_schedule: [] };
        for (const value of sortedTempDates) {
            itemsDates.competition_schedule.push({ date: value })
        }

        setEvents([...tempEvents]);
        setDisciplines([...tempDisciplines]);
        setDatesArray(itemsDates);

        let scheduleGroupedByDate = {};
        if (filteredScheduleArray?.length) scheduleGroupedByDate = groupByDate(filteredScheduleArray, 'startDate', getGlobalProps.timezone);

        let tempDatesScheduleMap = new Map();
        for (const { date } of itemsDates.competition_schedule) {
            const schedules = scheduleGroupedByDate[date];
            if (schedules?.length > 0) {
                tempDatesScheduleMap.set(date, schedules)
            }
        };
        setDatesScheduleMap(tempDatesScheduleMap);
    }, [mirs_date, mirs_event, mirs_discipline, data?.schedulesByNoc]);

    if (isError) {
        return <NotAvailable />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.schedulesByNoc) {
        return <NotAvailable />
    }


    const isSmallScreen = () => {
        return breakPoint === "md" || breakPoint === "sm" || breakPoint === "xs";
    }
    return (
        <>
            <Stack direction={"vertical"} className='selectors-container'>
                {
                    !isSmallScreen() && <div>
                        <DayList daysItems={datesArray} page="schedulebynoc" />
                    </div>
                }
                <Stack direction={"horizontal"} className="flex-wrap">
                    {isSmallScreen() && <SelectorDay daysItems={datesArray} page="schedulebynoc" />}
                    <SelectorNoc display_type={SELECTOR_DISPLAY_TYPE.COMBO} page='schedulebynoc' />
                    <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="schedulebynoc" disciplinesList={disciplines} useDisciplinesList={true} />
                    <SelectorEvent page='schedulebynoc' eventList={events} useEventList={true} />
                    <SelectorTimeZone />
                </Stack>
            </Stack>
            {[...datesScheduleMap].map(([startDate, scheduleData]) => {
                return (
                    <div key={startDate}>
                        <Accordion className='schedule-container' defaultActiveKey="0">
                            <Accordion.Item eventKey="0" >
                                <Accordion.Header className='schedule-title' >
                                    {/* <Noc/> */}
                                    <DateTime format={getDateTimeFormat('DayName-DayNum-MonthShort')} datetime={startDate} />
                                </Accordion.Header>
                                <Accordion.Body className="p-0">
                                    <NocScheduleTable data={scheduleData} key={`schedule-${mirs_noc}`} />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                )
            })}

        </>
    )

};


export default ScheduleByNoc

